// extracted by mini-css-extract-plugin
export default {"root":"JIu2jp","commentingAs":"FiBVjW","name":"tNpc1N","publishControls":"h4FfUG","avatar":"hE35mC","container":"H2EZ9y","textButton":"T1VgeV","text":"Mp6bjo"};